<template>
    <span class="nft-metadata-badge">
        <span v-if="url === undefined" class="skeleton">somewhere</span>

        <a v-bind:href="displayedUrl ? displayedUrl : ''" target="_blank" v-else-if="isIpfs" class="nft-metadata-badge__label">
            <icon-ipfs class="nft-metadata-badge__label__icon"/>
            <span v-pre class="nft-metadata-badge__label__text">IPFS</span>
        </a>

        <a v-on:click.prevent="sourceModalVisible = true" v-else-if="isOnchain" class="nft-metadata-badge__label">
            <icon-onchain class="nft-metadata-badge__label__icon"/>
            <span class="nft-metadata-badge__label__text" v-text="$t('nft.item.metadata_source_onchain')"/>
        </a>

        <a v-on:click.prevent="sourceModalVisible = true" v-else-if="!isOnchain && loader" class="nft-metadata-badge__label">
            <icon-offchain class="nft-metadata-badge__label__icon"/>
            <span class="nft-metadata-badge__label__text" v-text="$t('nft.item.metadata_source_offchain')"/>
        </a>

        <a v-bind:href="displayedUrl ? displayedUrl : ''" target="_blank" v-else class="nft-metadata-badge__label">
            <icon-offchain class="nft-metadata-badge__label__icon"/>
            <span class="nft-metadata-badge__label__text" v-text="$t('nft.item.metadata_source_offchain')"/>
        </a>

        <ui-modal v-if="loader" v-bind:isOpen.sync="sourceModalVisible">
            <template slot="header">
                {{$t('common.raw_metadata')}}
            </template>

            <div class="source-viewer" style="margin: 12px">
                <div class="source-viewer-code">
                    <div v-if="!rawSource" class="source-viewer-code__skeletons">
                        <span v-pre class="skeleton" style="width: 10%"></span>
                        <span v-pre class="skeleton" style="width: 60%"></span>
                        <span v-pre class="skeleton" style="width: 30%"></span>
                        <span v-pre class="skeleton" style="width: 20%"></span>
                        <span v-pre class="skeleton" style="width: 80%"></span>
                        <span v-pre class="skeleton" style="width: 60%"></span>
                    </div>

                    <pre v-else class="source-viewer-code__pre" style="max-height: 580px" v-text="rawSource"/>
                </div>
            </div>

            <div v-if="url" class="metadata-btn-container">
                <a v-bind:href="url" target="_blank" class="open-external-metadata-btn">
                    {{ $t('nft.item.metadata_open') }}
                </a>
            </div>
        </ui-modal>
    </span>
</template>

<script>
import IconOffchain from '@primer/octicons/build/svg/globe-16.svg?inline';
import IconOnchain from '@primer/octicons/build/svg/file-binary-16.svg?inline';
import IconIpfs from '@primer/octicons/build/svg/package-16.svg?inline';

export default {
    props: {
        url: String,
        loader: Function,
    },

    data() {
        return {
            sourceModalVisible: false,
            rawSource: null,
        };
    },

    watch: {
        async sourceModalVisible(isVisible) {
            if (isVisible && !this.rawSource) {
                this.rawSource = await this.loader();
            }
        },
    },

    computed: {
        isIpfs() {
            /* eslint no-useless-escape: "off" */
            return this.url && (this.url.match(/[\/\.]ipfs[\/\.]/) || this.url.startsWith('ipfs://'));
        },

        displayedUrl() {
            return this.isIpfs
                ? this.url.replace('ipfs://', 'https://ipfs.io/ipfs/')
                : this.url;
        },

        isOnchain() {
            return this.url === null;
        },
    },

    components: {
        IconOffchain, IconIpfs, IconOnchain,
    },
};
</script>

<style lang="scss">
.nft-metadata-badge {
    display: flex;
    align-items: center;
    &__label {
        display: inline-flex;
        align-items: center;
        &__icon {
            fill: currentColor;
            margin-right: 0.35em;
            width: 16px;
            height: 16px;
            transform: translateY(-1px);
        }
        &__text {
            //font-weight: 500;
            margin-right: 0.35em;
        }
    }
}

.metadata-btn-container {
    width: 100%;
    box-sizing: border-box;
    padding: 0 12px 12px;
}

.open-external-metadata-btn {
    display: block;
    text-decoration: none;
    text-align: center;
    width: 100%;
    padding: 12px 0!important;
    text-transform: uppercase;
    font-weight: 500;
    font-size: 16px;
    background-color: var(--big-blue-button-background);
    border-radius: 8px!important;
    cursor: pointer;
    color: white;
    transition: .15s background-color;

    &:hover {
        text-decoration: none;
        background-color: var(--big-blue-button-hover-background)!important;
    }
}
</style>
